import { ApiResps } from 'providers';
import { OperationType, StatusType } from '../StatusCard';

export type Operation = NonNullable<ApiResps['/remote-control/get-machine-info']['OPERATION']>;

export interface EconomyModeBarProps {
  checked: boolean;
  loading: boolean;
  openEconomyModeOffModalByManualMode: boolean;
  onClickCheck: () => void;
  onCloseEconomyModeOff: () => void;
}

export interface OperationButtonProps {
  readonly onClickModality: () => void;
  readonly operation: 'fan' | 'cool';
  readonly currentOperation: Operation;
  readonly disabled: boolean;
  readonly loading?: boolean;
}

export interface PowerButtonProps {
  readonly onClickModality: () => void;
  readonly loading?: boolean;
}

export type State = 'allow' | 'onlyfan' | 'forbid' | 'disabling' | 'eco' | 'enabling' | 'thermostat' | 'cool';

export type StatusCardOptions = {
  connection: boolean;
  status: StatusType | undefined;
  operation: OperationType | undefined;
  healthStatus: HealthStatus | undefined;
}

export enum HealthStatus {
  NO_ALERT = 'NO_ALERT',
  ALERT = 'ALERT',
  INOPERATIVE = 'INOPERATIVE',
}
